import makeApiRequest from 'src/lib/makeApiRequest';
import { API_URL } from 'src/constants/Endpoints';
import { SEARCH_OPERATORS_PRIMITIVE } from 'src/constants/SearchOperators';

export const getEventTicketsData =
  (organisation: string, eventId: number, productId: number) => makeApiRequest({
    method: 'POST',
    url: `${API_URL.eventTickets}?debug=1`,
    organisation,
    data: {
      fields: ['event_tickets.ticket_identifier'],
      filters: {
        and: [
          ['event_tickets.event_id', SEARCH_OPERATORS_PRIMITIVE.eq, eventId],
          ['event_tickets.product_id', SEARCH_OPERATORS_PRIMITIVE.eq, productId],
          ['event_tickets.status', SEARCH_OPERATORS_PRIMITIVE.ne, 'available'],
          ['event_tickets.deleted_at', SEARCH_OPERATORS_PRIMITIVE.null],
        ],
      },
    },
  });
